module.exports = __webpack_public_path__ + "static/img/Forrenewal.5ce3bd55.png";